import { motion } from 'framer-motion'

const ITEMS = [
  'ASHU CLEANING',
  'አሹ ፅዳት',
  'SOFA WASH',
  'HOME DEEP CLEAN',
  '★★★★★',
  'ADDIS ABABA',
  'ቤት ፅዳት',
  'MATTRESS CLEAN',
  'BOOK NOW'
]

interface MarqueeRowProps {
  items: string[]
  reverse?: boolean
  bg: string
  color: string
}

function MarqueeRow({ items, reverse = false, bg, color }: MarqueeRowProps) {
  const duplicated = [...items, ...items, ...items]

  return (
    <div
      style={{
        overflow: 'hidden',
        background: bg,
        height: 52,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <motion.div
        style={{
          display: 'flex',
          gap: 48,
          alignItems: 'center',
          whiteSpace: 'nowrap'
        }}
        animate={{
          x: reverse ? ['0%', '33.33%'] : ['0%', '-33.33%']
        }}
        transition={{ duration: 18, repeat: Infinity, ease: 'linear' }}
      >
        {duplicated.map((item, i) => (
          <span
            key={i}
            style={{
              fontFamily: 'Bebas Neue',
              fontSize: '1.3rem',
              color,
              letterSpacing: '0.05em',
              flexShrink: 0
            }}
          >
            {item}
            <span
              style={{
                margin: '0 16px',
                opacity: 0.4,
                fontSize: '0.6rem'
              }}
            >
              ✦
            </span>
          </span>
        ))}
      </motion.div>
    </div>
  )
}

export function Marquee() {
  return (
    <section style={{ overflow: 'hidden' }}>
      <MarqueeRow items={ITEMS} reverse={false} bg="var(--lime)" color="var(--black)" />
      <MarqueeRow items={ITEMS} reverse={true} bg="var(--black)" color="var(--lime)" />
    </section>
  )
}
